import bcrypt from "bcryptjs";

/**
 * RESOURCE ALLOCATION MANAGER - USER CREDENTIALS
 * =============================================
 * Username: admin | Password: icon2025#
 * Hash is public (shipped to browser) — bcrypt prevents reversal.
 * LOG_SECRET_HASH is in .env (backend only, never exposed).
 */

const PASSWORD_HASH = "$2b$10$LdXoFM7lNwMVLcHTwmCPPOACszdnPUExe7p/Wrhgu6lC/bmQygI2W";

const USERS = {
  admin: {
    username: "admin",
    passwordHash: PASSWORD_HASH,
  },
};

export const authenticateUser = async (username, password) => {
  try {
    if (!username || !password) {
      throw new Error("Username and password are required");
    }

    const user = USERS[username.toLowerCase()];
    if (!user) {
      throw new Error("Invalid username or password");
    }

    const isValidPassword = await bcrypt.compare(password, user.passwordHash);
    if (!isValidPassword) {
      throw new Error("Invalid username or password");
    }

    return {
      success: true,
      user: {
        username: user.username,
      },
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};

export const isAuthenticated = () => {
  return localStorage.getItem("isAuthenticated") === "true";
};

export const setAuthenticated = (value) => {
  localStorage.setItem("isAuthenticated", value.toString());
};

export const logout = () => {
  localStorage.removeItem("isAuthenticated");
  localStorage.removeItem("username");
};

export const getCurrentUser = () => {
  if (isAuthenticated()) {
    return localStorage.getItem("username");
  }
  return null;
};
